// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInline-cls1_8v7","cls2":"CiterightInline-cls2_gAH CiterightInline-cls1_8v7"};